<h1 mat-dialog-title>
  <i class="far fa-exclamation-triangle i-16 mr-4"></i>
  <span>Unsaved Changes</span>
</h1>
<div mat-dialog-content>
  <p class="main c-grey-5 fs-14 text-center">Unsaved changes have been detected!</p>
  <p class="c-grey-5 fs-14 text-center">Leaving this {{data.context || 'page'}} without saving will discard any unsaved edits.</p>  
</div>
<div mat-dialog-actions align="center">  
  <button trgButton color="outline" class="min-w-100" (click)="cancel()">Cancel</button>
  <button *ngIf="data.canDiscard" trgButton color="red-outline" class="min-w-100" (click)="discard()">Discard</button>
  <button *ngIf="data.canSave" trgButton color="primary" class="min-w-100" (click)="save()" cdkFocusInitial>Save</button>
</div>
